import { render, staticRenderFns } from "./QuickButtonsAudit.vue?vue&type=template&id=4efe7640&"
import script from "./QuickButtonsAudit.vue?vue&type=script&lang=js&"
export * from "./QuickButtonsAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4efe7640')) {
      api.createRecord('4efe7640', component.options)
    } else {
      api.reload('4efe7640', component.options)
    }
    module.hot.accept("./QuickButtonsAudit.vue?vue&type=template&id=4efe7640&", function () {
      api.rerender('4efe7640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/channels/QuickButtonsAudit.vue"
export default component.exports